import { LoadableAfterPaint } from '@confluence/loadable';

export const DefaultSpacePermissionsTabPortal = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DefaultSpacePermissionsTabPortal" */ '../src/DefaultSpacePermissionsTabPortal'
			)
		).DefaultSpacePermissionsTabPortal,
	name: 'DefaultSpacePermissionsTabPortal',
});
